//Author June Leow
//Date June 12th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, callBackGenerator, showMessage, formatDateTime} from '../../util/util';
import {Card, CardHeader, CardBody, Row, Col, Input, Button, Modal, ModalHeader, ModalBody} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  conditionComment:'',
  declineReasons:[],
  declineReason:'',
  conditionReasons:[],
  conditionreason:'',
  conditionFee:'',
  conditionTurntime:'',
  declineComment:'',
  conditionPopUp:false,
  declinePopUp:false,
  appraisal:{
    reference_num:'',
    property_street:'',
    property_city:'',
    property_state:'',
    property_zip:'',
    loan_num:'',
    loan_purpose:'',
    loan_type:'',
    datetime_submitted:'0000-00-00',
    status:'',
    borrower_f_name:'',
    borrower_l_name:'',
  },
  valid: false,
};

//reducer function that perform state update
const reducer = getReducer();


const Acceptance  = (props)=>{
  const controller = new AbortController();

  let id = useParams().id;
  let appraiserFk = useParams().appraiserFk;
  let newInitialState = Object.assign({}, initialState, {
    id:id,
    appraiserFk:appraiserFk
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);
  const apiCallBack = callBackGenerator(setState);
  const httpGetNoToken = getAPICallGenerator(props, {signal:controller.signal, noToken:true});
  const httpPostNoToken = postAPICallGenerator(props, {signal:controller.signal, noToken:true});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraisal();
    getConditionReasons();
    getDeclineReasons();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const conditionPopUpToggle=()=>{
    setState({conditionPopUp:!state.conditionPopUp});
  }

  const declinePopUpToggle=()=>{
    setState({declinePopUp:!state.declinePopUp});
  }

  //API call
  const getAppraisal=()=>{
    let callBack = (response)=>{console.log(response);
      let code = response.data.code;
      if(code==='00'){
        setState({appraisal:response.data.data});

        if(response.data.data.status==='Assigned'&&response.data.data.appraiser_fk ===state.appraiserFk)
          setState({valid:true});
      }
    };
    httpGetNoToken('appraisal/public/'+state.id, '', 'Oops, something went wrong and could not load the appraisal information. Please try again later.', callBack);
  }

  const getConditionReasons=()=>{
    const callBack = apiCallBack([{state:'conditionReasons', key:'data'}]);
    httpGetNoToken('appraisal/conditionReason/get', '', 'Oops, something went wrong and could not load the information of this appraisal. Please try again later.', callBack);
  }

  const conditionallyAccept=(e)=>{
    e.preventDefault();
    let parameters = [
      {
        field:'orderID',
        value:state.id
      },
      {
        field:'appraiserFk',
        value:state.appraiserFk
      },
      {
        field:'reason',
        value:state.conditionReason
      },
      {
        field:'fee',
        value:state.conditionFee
      },
      {
        field:'turntime',
        value:state.conditionTurntime
      },
      {
        field:'comment',
        value:state.conditionComment
      }
    ];

    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        setState({valid:false});
        conditionPopUpToggle();
      }
    };
    console.log(parameters)
    httpPostNoToken('appraisal/assignment/noSession/conditionallyAccept', parameters, 'Assignment conditionally accepted successfully.', 'Oops, something went wrong and could not conditionally accept the assignment. Please try again later.', callBack);
  }

  const setAcceptance=(action)=>{
    let successMsg = 'Assignment accepted successfully.';
    if(action==='no')
      successMsg = 'Assignment declined successfully.';
    let errorMsg = 'Oops, something went wrong and could not accept the assignment. Please try again later.';
    if(action==='no')
      errorMsg = 'Oops, something went wrong and could not decline the assignment. Please try again later.';

    let parameters = [
      {
        field:'orderID',
        value:state.id
      },
      {
        field:'appraiserFk',
        value:state.appraiserFk
      },
      {
        field:'action',
        value:action
      }
    ];

    if(action==='no'){
      let tmp = {
        field:'reason',
        value:state.declineReason
      };

      parameters.push(tmp);

      tmp = {
        field:'comment',
        value:state.declineComment
      }

      parameters.push(tmp);
    }

    let callBack = (response)=>{
      let code = response.data.code;

      if(code==='00'){
        setState({valid:false});
        if(action==='no')
          declinePopUpToggle();
      }
    };
    console.log(parameters)
    let url = 'appraisal/assignment/noSession/acceptance';
    if(state.appraisal.status==='Auto Assigning')
      url = 'autoAssign/noSession/acceptance';
    httpPostNoToken(url, parameters, successMsg, errorMsg, callBack);
  }

  const getDeclineReasons=()=>{
    let url = 'appraisal/declineReason/get';
    const callBack = apiCallBack([{state:'declineReasons', key:'data'}]);
    httpGetNoToken('appraisal/declineReason/get', '', 'Oops, something went wrong and could not load the information of this appraisal. Please try again later.', callBack);
  }

  //render
  let required = false;
  let conditionFee, conditionTurntime, conditionTurntimeValue;

  if(state.conditionTurntime!=='')
    conditionTurntimeValue = moment(state.conditionTurntime).toDate();

  if(state.conditionReason==='Fee'||state.conditionReason==='Fee & Turntime')
    conditionFee =
    <div>
      <label>Fee</label>
      <Input type="text" value={state.conditionFee} onChange={(e)=>setState({conditionFee:e.target.value})}/>
    </div>;

  if(state.conditionReason==='Turntime'||state.conditionReason==='Fee & Turntime')
    conditionTurntime =
    <div>
      <label>Due date</label><br/>
      <DatePicker
        onChangeRaw={(e)=>{e.preventDefault()}}
        className="form-control"
        selected={conditionTurntimeValue}
        onChange={(text)=>{setState({conditionTurntime:text.toLocaleDateString('en-CA')})}}
      />
    </div>;

  if(state.declineReason==='Other')
    required = true;

  let action;

  if(state.valid)
    action = <center>
      <b>You've been assigned a new order, the engagement letter can be found within the documents storage. Do you accept the assignment?</b><br/><font color="red">**By accepting the Assignment electronically, Appraiser confirms that the Engagement letter is in accordance with Appraiser’s understanding and agrees to the terms of this Assignment.**</font><br/><br/>
      <Button style={{width:'170px'}} color="warning" onClick={()=>setAcceptance('yes')}><i className="fa fa-check"></i> Accept</Button>&nbsp;&nbsp;&nbsp;&nbsp;
      <Button style={{width:'170px'}} color="warning" onClick={conditionPopUpToggle}><i className="fa fa-info"></i> Conditionally accept</Button>&nbsp;&nbsp;&nbsp;&nbsp;
      <Button style={{width:'170px'}} color="warning" onClick={declinePopUpToggle}><i className="fa fa-times"></i> Decline</Button>
    </center>;
  else if(!state.valid&&state.appraisal.reference_num!==''){
    if(state.appraisal.appraiser_fk!==state.appraiserFk){
      action = <center>
        The assignment acceptance link is expired, please reach out to us about the order status.
      </center>
    }
    else{
      action = <center>
        This order had been accepted/declined.
      </center>
    }
  }
  else {
    action = <center>
      The assignment acceptance link is expired, please reach out to us about the order status.
    </center>
  }



  return (
    <div>
      <div className="topbar">
          <div className="topbar-logo-container">
            <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
          </div>
      </div>
      <div className="padding">
        <Row>
          <Col sm="1">

          </Col>
          <Col sm="10">
            <Card style={{background:'#f5f5f5'}}>
              <CardHeader className="header-color">
                <center>
                    <i className="fa fa-edit"></i> Appraisal acceptance
                </center>
              </CardHeader>
              <CardBody>
                <div style={{background:'white', border:'1px solid #d2d2d2',padding:'5px',borderRadius:'5px'}}>
                  <label>Reference #:&nbsp;&nbsp;</label>
                  {state.appraisal.reference_num}

                  <br/>
                  <label>Status:&nbsp;&nbsp;</label>
                  {state.appraisal.status}

                  <br/>
                  <label>Property address:&nbsp;&nbsp;</label>
                  {state.appraisal.property_street+' '+state.appraisal.property_city+', '+state.appraisal.property_state+' '+state.appraisal.property_zip}

                  <br/>
                  <label>Borrower:&nbsp;&nbsp;</label>
                  {state.appraisal.borrower_f_name+' '+state.appraisal.borrower_l_name}

                  <br/>
                  <label>Loan purpose:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_purpose}

                  <br/>
                  <label>Loan type:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_type}

                  <br/>
                  <label>Loan #:&nbsp;&nbsp;</label>
                  {state.appraisal.loan_num}

                  <br/>
                  <label>Date submitted:&nbsp;&nbsp;</label>
                  {formatDateTime(state.appraisal.datetime_submitted)}

                  <br/>
                </div>
                <div className="my-divider"></div>
                <Modal className="my-modal" isOpen={state.declinePopUp} toggle={declinePopUpToggle} >
                  <ModalHeader hidden={true} toggle={declinePopUpToggle}></ModalHeader>
                  <ModalBody>
                    <form onSubmit={(e)=>{e.preventDefault();setAcceptance('no')}}>
                      <label>Reason</label>
                      <Input required="true" type="select" onChange={(e)=>setState({declineReason:e.target.value})}>
                        <option key=""></option>
                        {
                          state.declineReasons.map(
                            (reason,index)=>{
                              return <option key={index} value={reason.reason}>{reason.reason}</option>
                            }
                          )
                        }
                      </Input>
                      <br/>
                      <label>Comment</label>
                      <Input required={required} onChange={(e)=>setState({declineComment:e.target.value})} type="textarea" rows="5" style={{resize:'none'}}></Input>
                      <br/>

                      <b><font color="red">*</font>By declining this assignment you will no longer be able to access this order.</b>
                      <div className="my-divider">&nbsp;</div>
                      <center>
                        <Button color="info" onClick={declinePopUpToggle}>Close</Button>&nbsp;
                        <Button color="danger">Decline</Button>
                      </center>
                    </form>
                  </ModalBody>
                </Modal>

                <Modal className="my-modal" isOpen={state.conditionPopUp} toggle={conditionPopUpToggle} >
                  <ModalHeader hidden={true} toggle={conditionPopUpToggle}></ModalHeader>
                  <ModalBody>
                    <form onSubmit={conditionallyAccept}>
                      <label>Reason</label>
                      <Input required="true" type="select" onChange={(e)=>setState({conditionReason:e.target.value})}>
                        <option key=""></option>
                        {
                          state.conditionReasons.map(
                            (reason,index)=>{
                              return <option key={index} value={reason.reason}>{reason.label}</option>
                            }
                          )
                        }
                      </Input>
                      <br/>
                      {conditionFee}
                      {conditionTurntime}
                      <label>Comment</label>
                      <Input required={required} onChange={(e)=>setState({conditionComment:e.target.value})} type="textarea" rows="5" style={{resize:'none'}}></Input>
                      <br/>

                      <b><font color="red">*</font>By conditionally accept this assignment, the order will be temporary taken away from you for consideration of your request.</b>
                      <div className="my-divider">&nbsp;</div>
                      <center>
                        <Button color="info" onClick={conditionPopUpToggle}>Close</Button>&nbsp;
                        <Button color="danger">Conditionally accept</Button>
                      </center>
                    </form>
                  </ModalBody>
                </Modal>
                <div style={{background:'white', border:'1px solid #d2d2d2',padding:'5px',borderRadius:'5px'}}>
                  <br/>
                  {action}
                  <br/>
                </div>
                <br/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}


export default Acceptance;
